export default function formatBoolean(boolean) {
  return boolean ? 'True' : 'False';
}
